import { render, staticRenderFns } from "./RequestLoginForm.vue?vue&type=template&id=afc60296&scoped=true&"
import script from "./RequestLoginForm.vue?vue&type=script&lang=js&"
export * from "./RequestLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestLoginForm.vue?vue&type=style&index=0&id=afc60296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc60296",
  null
  
)

export default component.exports